import { Reveal } from "@/components/Reveal";

export const LegalPage = ({ title, updated, children }) => (
  <div className="min-h-screen bg-void px-6 pb-32 pt-32 lg:px-12 lg:pt-40">
    <div className="max-w-3xl">
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.4em] text-gold">Orologi &amp; Preziosi</p>
        <h1 className="mt-4 font-serif text-4xl font-light tracking-tight text-ivory sm:text-5xl">{title}</h1>
        <p className="mt-3 font-mono text-[11px] text-muted">Ultimo aggiornamento: {updated}</p>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-12 space-y-10 text-sm leading-relaxed text-muted [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:font-light [&_h2]:text-ivory [&_a]:text-gold [&_a]:underline [&_a]:underline-offset-4 [&_li]:ml-4 [&_li]:list-disc [&_strong]:text-ivory [&_ul]:space-y-2">
          {children}
        </div>
      </Reveal>
    </div>
  </div>
);
